import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Divider } from "@mui/material";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import AssignDepartmentDialog from "./AssignDepartmentDialog";

const RiteUserDetails = ({ user }) => {
  const token = getDecryptedAccessToken();
  const [data, setData] = useState(null);
  const [dialog, setDialog] = useState(false);

  const fetchUser = async () => {
    const res = await ApiServices.get(`/api/v1/admin/users/${user.id}/`, {
      Authorization: `Bearer ${token}`,
    });

    setData(res.data);
  };

  useEffect(() => {
    fetchUser();
  }, []);

  if (!data) return null;

  return (
    <Box>
      <Typography variant="h6">
        {data.first_name} {data.last_name}
      </Typography>

      <Typography>{data.email}</Typography>
      <Typography>{data.phone}</Typography>
      <Typography>User Type: {data.user_type}</Typography>

      <Button
        variant="contained"
        sx={{ mt: 2 }}
        onClick={() => setDialog(true)}
      >
        Assign Department
      </Button>

      <Divider sx={{ my: 3 }} />

      <Typography variant="h6">Department Assignments</Typography>

      {data.department_assignments?.map((d, i) => (
        <Box key={i} sx={{ mt: 1 }}>
          <Typography>
            {d.department.title} — {d.position_in_dept}
            {d.is_primary && " (Primary)"}
          </Typography>
        </Box>
      ))}

      <AssignDepartmentDialog
        open={dialog}
        onClose={() => setDialog(false)}
        userId={user.id}
        onAssigned={fetchUser}
      />
    </Box>
  );
};

export default RiteUserDetails;
